import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

// Interfaces
import { Order } from '../interfaces/order'
import { FilterService } from './baseListFilter.service';
import { SharedDataService } from './shared-data.service';
import { Message } from 'app/interfaces/message';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends FilterService {
  private errorMessage: Message;

  orderId = new Subject<string>()
  constructor(
    protected httpClient: HttpClient,
    protected sharedData: SharedDataService,
  ) {
    super()
    this.errorMessage = {
      status: 500
      , error: {errorMessage: 'Não Foi Possível Comunicar Com o Servidor!' }
      , ok: false
    }
  }

  fetchOrderData(orderId: string): Observable<Order> {
    const url = `$companyId/order/${orderId}`
    const orderData = new Subject<Order>();
    this.httpClient.get<Order>(url).subscribe(
      data => {
        orderData.next(data)
      }, error => {
        orderData.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return orderData.asObservable();
  }

  getDataFiltered(params: HttpParams): Observable<HttpResponse<Order[]>> {
    return this.httpClient.get<Order[]>(`$companyId/order`, {observe: 'response', params})
  }

  setOrderId(orderId: string){
    this.orderId.next(orderId)
  }

  getOrderId(): Observable<string> {
    return this.orderId.asObservable()
  }

  saveScheduledDate(body: any): Observable<HttpResponse<Order>> {
    return this.httpClient.post<any>(`$companyId/order`, body, { observe: 'response' })
  }

}
